(function () {
  const isEnglish =
    document.documentElement.lang &&
    document.documentElement.lang.toLowerCase().startsWith("en");

  if (!isEnglish) return;

  const translations = {
    "Guía de tallas": "Size guide",
    "Medidas": "Measurements",
    "Talla": "Size",
    "ALTURA (A)": "HEIGHT (A)",
    "ANCHURA (B)": "WIDTH (B)",
    "LONGITUD MANGA (C)": "SLEEVE LENGTH (C)"
  };

  function translatePandaSizeChart() {

    // Botón de Panda
    document
      .querySelectorAll("#panda-SizeChart-Btn span")
      .forEach(function (element) {
        const text = element.textContent.trim();

        if (translations[text]) {
          element.textContent = translations[text];
        }
      });

    // Contenido de la tabla
    const popup = document.querySelector("#panda-parent-container");

    if (!popup) return;

    popup
      .querySelectorAll("#sd-title-tag, .panda-table-Item th")
      .forEach(function (element) {
        const text = element.textContent.trim();

        if (translations[text]) {
          element.textContent = translations[text];
        }
      });
  }

  translatePandaSizeChart();

  const observer = new MutationObserver(function () {
    translatePandaSizeChart();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();